import React, {useEffect, useRef, useState} from "react";
import Calendar from 'react-calendar';
import moment from "moment";
import './Schedule.css';
import {IoIosArrowDown, IoIosArrowUp} from "react-icons/io";
import getBaseUrl from "../../helpers/http";
import {toast} from "react-toastify";
import {useTranslation} from "react-i18next";
import ScheduleListItem from "../../components/ScheduleListItem";
import {LuLoader2} from "react-icons/lu";
import { Helmet, HelmetProvider } from 'react-helmet-async';

const Schedule = () => {


    const scrollContainerRef = useRef(null);
    const windowWidth = useRef(window.innerWidth);

    const {t, i18n} = useTranslation();

    const minDate = moment().set('date', 1).set('month', 0).toDate()
    const maxDate = moment().set('date', 1).set('month', 11).toDate()

    const [fetchError, setFetchError] = useState(-1);
    const [scheduleList, setScheduleList] = useState();
    const [markedList, setMarkedList] = useState([]);

    const scrollToElement = (date) => {
        let id = null;
        const activeIds = [];
        const allElements = document.querySelectorAll('.activated-list');
        allElements.forEach((element) => {
            element.classList.remove('activated-list');
        });
        scheduleList?.forEach(e => {
            if (moment(date).format('YYYY-MM-DD') === e.DATA) {
                activeIds.push('list' + e.D_ID)
                if (id === null) {
                    id = e.D_ID;
                }
            }
        });
        activeIds.forEach(e => {
            document.getElementById(e).classList.add('activated-list')
        })
        if (id !== null) {
            const element = document.getElementById('list' + id);
            if (element && scrollContainerRef.current) {
                if (windowWidth.current > 1024)
                    scrollContainerRef.current.scrollTop = element.offsetTop;
                else
                    scrollContainerRef.current.scrollTop = element.offsetTop - 350;
            }
        }
    };

    const currentLang = i18n.language;

    useEffect(() => {
        const fetchData = async () => {
            setFetchError(-1)
            try {
                const minDate = moment().set('date', 1).set('month', 0).toDate()
                const maxDate = moment().add(1, 'year').set('date', 1).set('month', 0).toDate()
                const startDate = moment(minDate).format("YYYY-MM-DD")
                const endDate = moment(maxDate).format("YYYY-MM-DD")
                const scheduleResponse = await fetch(getBaseUrl() +
                    `schedule/data?lang=${currentLang}&startdate=${startDate}&enddate=${endDate}`, {
                    method: 'POST'
                });

                const scheduleResult = await scheduleResponse.json();
                const mark = []
                if (scheduleResult.success) {
                    setScheduleList(scheduleResult.result)
                    scheduleResult.result.forEach(a => {
                        mark.push(a.DATA)
                    })
                    setMarkedList(mark)
                    setFetchError(0);
                } else {
                    setFetchError(1);
                    toast.error(scheduleResult.result)
                }
            } catch (error) {
                setFetchError(2);
                toast.error(t('schedule.errorCatch'))
                console.log('error 1', error);
            }

        };

        fetchData().then()
    }, [currentLang, t]);

    return (
        <> 
        <HelmetProvider>
            <Helmet>
                <title>{t('root.meta.schedule.title')}</title>
                <meta property="description" content={t('root.meta.schedule.description')}/>
                <meta property="og:site_name" content={t('root.meta.schedule.title')}/>
                <meta property="og:title" content={t('root.meta.schedule.title')}/>
                <meta property="og:description" content={t('root.meta.schedule.description')}/>
            </Helmet>
        </HelmetProvider>
            <div className={"container mx-auto mt-5 px-5"}>
                <div className={"grid grid-cols-1 border-b-2 pt-4 pb-4"}>
                    <p className={"text-4xl text-[#163578] uppercase"}>{t('schedule.mainTitle')}</p>
                </div>
                <div className={"grid grid-cols-1 pt-6 pb-6"}>
                    <p className={""}>{t('schedule.subTitle')}</p>
                </div>
            </div>

            {fetchError === 0 ? <div
                className="relative mt-2"
            >
                <div
                    className="relative w-full overflow-hidden after:clear-both after:block after:content-['']">

                    <img
                        src="/images/schedule-banner.webp"
                        className={"block w-full"}
                        alt="lg-sm"/>


                    <div
                        className={"container mx-auto grid grid-cols-1 lg:grid-cols-4 lg:gap-4 px-4 lg:px-4 relative bottom-5 sm:bottom-14 md:bottom-20 lg:bottom-28 xl:bottom-36"}>

                        <div className={"col-span-1"}>
                            <Calendar
                                className={"w-auto h-full my-auto rounded-2xl border-0 bg-white shadow-[0px_4px_4px_0px_rgb(0,0,0,0.25)] px-7 py-4"}
                                onChange={scrollToElement}
                                locale={currentLang}
                                minDate={minDate}
                                maxDate={maxDate}
                                nextLabel={<IoIosArrowUp className={"m-auto text-xl text-[#163578]"}/>}
                                prevLabel={<IoIosArrowDown className={"m-auto text-xl text-[#163578]"}/>}
                                formatShortWeekday={(locale, date) =>
                                    new Intl.DateTimeFormat(locale, {weekday: 'short'}).format(date)
                                }
                                tileClassName={({date}) => {
                                    if (markedList.find(x => x === moment(date).format("YYYY-MM-DD"))) {
                                        return 'highlight'
                                    }
                                }}/>
                        </div>
                        <div className={"col-span-3 mt-6 lg:mt-0"}>
                            <div className={"flex flex-col gap-2 overflow-y-scroll h-[21rem]"}
                                 ref={scrollContainerRef}>
                                {
                                    scheduleList?.map(e =>
                                        <ScheduleListItem key={e.D_ID} id={"list" + e.D_ID} title={e.NAME} date={e.DATA}
                                                          onDate={moment(e.DATE).format("YYYY.MM")}/>
                                    )
                                }
                            </div>
                        </div>

                    </div>

                </div>


            </div> : <>
                <img
                    src="/images/schedule-banner.webp"
                    className={"block w-full blur-sm"}
                    alt="lg-sm"/>

                <div className="relative bottom-44 flex justify-center items-center h-screen">
                    <LuLoader2 size={"4em"} color={"white"} className={"animate-spin "}/>
                </div>
            </>}

        </>
    )
};

export default Schedule;